export default __webpack_public_path__ + "static/media/TassAppFullLogo.f0b88250.svg";